const NeedHelp = () => {
  return (
    <div className="rounded-2xl bg-white p-4 shadow-sm ring-1 ring-slate-100">
      <h3 className="text-lg font-extrabold text-slate-900">Need Help?</h3>
      <p className="mt-2 text-sm text-slate-600">
        Contact us directly for product availability or bulk order support.
      </p>
      <p className="mt-3 text-base font-bold text-slate-900">01971787661</p>
      <button
        type="button"
        className="mt-3 rounded-md border border-slate-300 px-3 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-100"
      >
        <a href={`tel:01971787661`} target="_blank" rel="noopener noreferrer">
          Contact Support
        </a>
      </button>
    </div>
  );
};

export default NeedHelp;
